<div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select [class.ng-select-fill]="!tableStyle" [formControl]="fc" [placeholder]="field.name" appendTo="body">
        @for (user of users$ | async; track user.id) {
            <ng-option [value]="user.id">
                {{ user.name }}
            </ng-option>
        }
    </ng-select>

    <mat-error [control]="fc"></mat-error>

    @if (projectmanagerChange; as change) {
        <mat-hint class="text-ellipsis">
            {{ change.created_at | date: 'EEE d MMM yyyy' }} -
            {{ (allUsers | byId: change.changed_by_id)?.name ?? 'Onbekend' }}
        </mat-hint>
    }
</div>
